import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import PreviaEmail from '../../components/PreviaEmail.jsx';
import {TITULO_PREVIA_EMAIL} from '../../components/recursos/envioEmails.js';

const useStyles = makeStyles(() => ({
    root: {
        width: 800,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'}
}));

/* Prévia do modelo de e-mail da situação (assunto + corpo HTML). */
export default function DialogPreviaEmail(props) {
    const {open, onClose, assunto = '', corpo = ''} = props;
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            scroll='body'
            classes={{paper: classes.root}}
            aria-labelledby='dialog-previa-email-titulo'>
            <DialogTitle id='dialog-previa-email-titulo'>{TITULO_PREVIA_EMAIL}</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <PreviaEmail assunto={assunto} corpo={corpo}/>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
            </DialogActions>
        </Dialog>
    );
}

DialogPreviaEmail.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    /* Assunto do modelo (texto). */
    assunto: PropTypes.string,
    /* Corpo do modelo (HTML). */
    corpo: PropTypes.string
};
